import type { Container, Sprite } from 'pixi.js';
import { onLayoutPopulated } from '../populate';
import { insertAvatar } from '../../../game/utils/insertAvatar';
import type { App } from '../../../app/App';

export function layoutUserAvatarSPL(app: App): void {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  onLayoutPopulated.connect((layout: { root: Container; userAvatar_SPL?: Sprite[] | Sprite }) => {
    if (!layout.userAvatar_SPL) return;

    const placeholders = Array.isArray(layout.userAvatar_SPL) ? layout.userAvatar_SPL : [layout.userAvatar_SPL];

    const { avatarUrl } = app.platform.getCurrentPlayer();

    if (!avatarUrl) return;

    placeholders.forEach((placeholder) => {
      void insertAvatar(placeholder, avatarUrl);
    });
  });
}
